import { genPopulateAttr } from '@utils/util';

export const homePageAttributes = (): string => {
  // Strapi 5: only include leaf-level populate paths.
  // Parent paths (e.g. ['hero_carousel']) conflict with deep paths
  // (e.g. ['hero_carousel', 'background_asset']) when both are =true.
  const attributes = [
    ['hero_carousel', 'background_asset'],
    ['hero_carousel', 'link'],
  ];
  return attributes.map(it => genPopulateAttr(it)).join('&');
};
